<template>
    <v-dialog max-width="800" :value="value" @input="$emit('input', $event)">
        <v-card class="neu-glow pb-1">
            <v-card-title class="text-h5 mb-3"
            >
            Istruzioni Sale
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click.native="$emit('input', false)">
                    <v-icon color="info">mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Esci</span>
            </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1 mb-0 pb-3">
                <v-col md="6" cols="12">
                    <p>
                        Una volta definite le aree, si possono dividere le stesse in unità logiche, solitamente in <strong>Sale</strong>.
                        <br>Non vi sono limiti al numero di Sale o altre suddivisioni: queste suddivisioni non sono selezionabili dal cliente ma è l'operatore che assegna ogni prenotazione nella sala che ritiene opportuna.
                    </p>
                    <p>
                       Al fine di evitare perdite di dati, è sconsigliato cancellare una sala per poi ricrearne un'altra immediatamente dopo, a meno che non si voglia ottenere appunto ottenere tale effetto:
                       <br>Si consiglia piuttosto di modificare i parametri della sala
                    </p>  
                </v-col>
                <v-col md="6" cols="12">
                    <p>
                       Il campo <strong>Colonne</strong> serve ad ottimizzare la grafica della sala, ovvero suddividere lo schermo in un determinato numero di colonne.
                       <br>E' opportuno definire questo parametro prima di inserire i tavoli nel tabella Tavoli, per evitare disallineamenti
                    </p>
                    <p>
                        Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati. Cliccarlo per rendere definitive le modifiche
                    </p>
                </v-col>
                <v-col cols="12">
                    <p class="error--text">
                        <strong>Importante </strong> La cancellazione di una sala comporta l'automatica cancellazione a cascata anche di tutti i <strong>Tavoli</strong> e delle combinazioni per l'assegnazione automatica collegati alla sala stessa: Procedere con cautela!!
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template> 
<script>
    export default
    {
        props:['value'],
        data () {
            return {
                dialog:false,
            }
        },
    }
</script>